<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false" @close="close()">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '90px'">
      <div class="line-box">
           <el-form-item  label="城市" prop="city" class="styW">
              <el-select class="hundred"  v-model="dataForm.city" filterable clearable placeholder="请选择城市">
                  <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
    
      <el-form-item label="手机号" prop="mobile" class="styW">
          <el-input class="hundred"  v-model="dataForm.mobile" placeholder="手机号"></el-input>
      </el-form-item>

     
      <el-form-item  label="公司名称" prop="companyName" class="styW">
              <el-select class="hundred"  v-model="dataForm.companyName" filterable clearable placeholder="公司名称">
                  <el-option
                          v-for="item in companyList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
     
      
    

      <el-form-item  label="状态" prop="status" class="styW">
          <el-select class="hundred" v-model="dataForm.status" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in statusList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>

      <el-form-item  label="加密方式" prop="encrypt" class="styW">
          <el-select class="hundred" v-model="dataForm.encrypt" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in encryptList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>
      
     
      <!-- <el-form-item label="手机加密码" prop="telEncrypt">
          <el-input  v-model="dataForm.telEncrypt" placeholder="手机加密码"></el-input>
      </el-form-item> -->
     
      </div>
      <el-form-item v-if="!dataForm.id" label="上传排重包" prop="file" class="styW">
          <input class="file" type="file" accept="text/plain" ref="uploadFile2" @change="upLoad()">
        </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { getCompanies } from '../../../api/list'

export default {
  async mounted(){
    
    
  },
  data () {
    return {
      visible: false,
      fd:null,
      citys:[],
      companyList:[],
      
      statusList:[
        {
            'label':'停用',
            'value':0,
        },
        {
            'label':'正常',
            'value':1,
        }
      ],
      encryptList:[
        {
            'label':'sha256',
            'value':'sha256',
        },
        {
            'label':'md5',
            'value':'md5',
        }
      ],
      dataForm: {
        city:'',
        company: '',
        mobile: '',
        status: '',
        encrypt: '',
        companyName:'',
      }
    }
  },

  computed: {
    dataRule () {
      return {
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // city: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        encrypt: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // file: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // mobile: [
        // { required: true, message: "请输入手机号", trigger: "blur" },
        //   {
        //     pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
        //     message: "请输入正确的手机号码",
        //   },
        // ],
      }
    }
  },
  methods: {
    close(){
      if(!this.dataForm.id){
            this.$refs.uploadFile2.value = null
        }
    },
  async init () {
      this.visible = true
      let res = await getCompanies()
        if(res.data.code == 0){
        this.companyList = res.data.data.list.map(item => ({value:item.id,label:item.name,}))
     
        }else{
          this.$mesage.error(res.data.msg)
        }
      this.getCityOptions();
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    upLoad(){
 
  },
  handleSelectedImg(){
    this.$refs.uploadFile2.click()
  },
    async getCityOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.citys=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.citys.push({label:element.dictLabel,value:element.dictValue})
                  })
                  /*let citys = {}
                  for(let i = 0; i< res.data.length; i++){
                      citys[i].value=res.data[i].dictValue
                      citys[i].label=res.data[i].dictLabel
                  }*/
              }
          }).catch(() => {})
      },
    // 获取信息
    getInfo () {
      this.$http.get(`/zy/repeatmobile/info/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    //js

    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if(!this.dataForm.id){
          let forObj = {
                file: '',
                city:'',
                // company: '',
                mobile: '',
                status: '',
                encrypt: '',
                companyName:'',
           }

          this.fd = new FormData();
         for (const key in forObj) {
          console.log(key)
          if(key == 'file'){
            console.log(this.$refs.uploadFile2.files[0])
            this.fd.append("file", this.$refs.uploadFile2.files[0],);
            
          }else{
            this.fd.append(key, this.dataForm[key]);
          }
         }
         console.log(this.fd.get('file'))
        }
        
        this.$http[!this.dataForm.id ? 'post' : 'put']('/zy/repeatmobile',this.dataForm.id ? this.dataForm : this.fd,{
          headers: {'Content-Type': 'application/json'},
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
        
          if(!this.dataForm.id){
            this.$refs.uploadFile2.value = null
        }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style scoped lang="scss">
 .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .styW{
    width: 390px;
  }
</style>
